import { lazy } from 'react';

export const PatternStudioLabPageLazy = lazy(
    () => import('./pattern-studio-lab-page'),
);
